module.exports = __webpack_public_path__ + "05285164955c694105963b895a36aa2e.svg";